import { Host, h } from '@stencil/core';
export class AibaVideo {
  constructor() {
    this.data = undefined;
    this.handlers = undefined;
    this.videoActive = false;
  }
  componentDidLoad() {
    this.handlers && this.handlers.handleVideoDidLoad(this.data.videoId, this.element, this.data.videoApi);
  }
  playvideo(e) {
    this.videoActive = true;
    this.handlers && this.handlers.playVideoHandler(e);
  }
  render() {
    if (typeof this.data === 'string') {
      this.videoData = JSON.parse(this.data);
    }
    else {
      this.videoData = this.data;
    }
    return (h(Host, null, h("div", { class: "video" }, h("div", { class: "video__wrapper" }, h("div", { class: `video__previewImage ${this.videoActive ? 'hide' : ''}` }, h("img", { src: this.videoData.previewImageUrl, alt: this.videoData.previewImageAltText }), h("button", { class: "btn-player", onClick: (e) => this.playvideo(e) }, h("img", { src: this.videoData.buttonIcon, alt: "icon" }))), h("div", { class: `video__overlay ${this.videoActive ? 'active' : ''}` }, h("div", { class: "video_iframe" }))), h("div", { class: "video__content" }, this.videoData.videoHeading && h("h2", null, this.videoData.videoHeading), this.videoData.videoDescription && h("p", null, this.videoData.videoDescription)))));
  }
  static get is() { return "aiba-video"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-video.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-video.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "videoActive": {}
    };
  }
  static get elementRef() { return "element"; }
}
//# sourceMappingURL=aiba-video.js.map
